import { gql, useFragment } from '@apollo/client'

import { INDEPENDENT_CHILDREN_GQL_SCHEMA, STORY_BASE_GQL_SCHEMA } from '@/requests/apollo/schema.ts'

export const useQueryStory = (id: string) => {
  const { data: story } = useFragment({
    fragment: gql`fragment StoryFragment on Story {
      ${STORY_BASE_GQL_SCHEMA}
      ${INDEPENDENT_CHILDREN_GQL_SCHEMA}
    }`,
    fragmentName: 'StoryFragment',
    from: { __typename: 'Story', id },
  })

  return { story }
}
